// extracted by mini-css-extract-plugin
export var downArrow = "_7f-0";
export var infoTooltipIcon = "_7f-3";
export var label = "_7f-1";
export var optionCard = "_7f-4";
export var upArrow = "_7f-2";